import React, { Fragment } from 'react';

import { Row } from "./Row";
import { AddExtraProps } from './With2Tabs';


export class With3Tabs extends React.PureComponent {
	/*	props:
				-(optionnel) startingtab 	-> 1 or 2 or 3, default 1
				- title_tab1 				-> string
				- title_tab2 			  	-> string
				- title_tab3 			  	-> string
				- content_tab1 				-> JSX
				- content_tab2 				-> JSX
				- content_tab3 				-> JSX
	*/
	
	static defaultProps = {
		startingtab: 1,
	}

	constructor(props) {
		super(props)
		this.state = {
			displayedtab: this.props.startingtab
		};
		this.handleClick = this.handleClick.bind(this)
		this.default_tab_classname = "button item"
	}

	handleClick(e) {
		this.setState({ displayedtab: e.target.id })
	}
	
	render() {
		
		//prop injection as we are going to do doesn't work with Fragments
		// so in case it is one, we will wrap it around a span (or div ?)
		function checkifFragmentandaddspan(jsxtocheck) {
			var newjsx = AddExtraProps(jsxtocheck, {}) //copy with no injection
			var isfragment = newjsx.type === Fragment
			if (isfragment) {
				newjsx = <span>{newjsx}</span>
			}
			return newjsx
		}

		// adding fragment around necessary otherwise the tab switcher doesn't work
		var content_tab1 = <Fragment>{this.props.content_tab1}</Fragment>
		var content_tab2 = <Fragment>{this.props.content_tab2}</Fragment>
		var content_tab3 = <Fragment>{this.props.content_tab3}</Fragment>

		var safe_content_tab1 = checkifFragmentandaddspan(content_tab1)
		var safe_content_tab2 = checkifFragmentandaddspan(content_tab2)
		var safe_content_tab3 = checkifFragmentandaddspan(content_tab3)

		// using hiding props prevents unmounting component & losing state
		var hidden_tab1 = true, hidden_tab2 = true, hidden_tab3 = true

		if (this.state.displayedtab === "1") {
			hidden_tab1 = false
		} else if (this.state.displayedtab === "2") {
			hidden_tab2 = false
		} else if (this.state.displayedtab === "3") {
			hidden_tab3 = false
		}

		//prop injection
		safe_content_tab1 = AddExtraProps(safe_content_tab1, { hidden: hidden_tab1 })
		safe_content_tab2 = AddExtraProps(safe_content_tab2, { hidden: hidden_tab2 })
		safe_content_tab3 = AddExtraProps(safe_content_tab3, { hidden: hidden_tab3 })

		var class_tab1 = "", class_tab2 = "", class_tab3 = ""
		var displayedtab = parseInt(this.state.displayedtab) // can be string

		if (displayedtab === 1)
			class_tab1 = "selected"
		if (displayedtab === 2)
			class_tab2 = "selected"
		if (displayedtab === 3)
			class_tab3 = "selected"

		var tabstyle = {
			paddingRight: "0px",
			paddingLeft: "0px",
			border: "none",
			borderBottom: "1px solid white"
		}

		//let's make top tab menu full width
		var rowStyle = {
			position: "relative",
			width: 'calc(100% + 60px)',
			left: "-40px"
		}

		// Filtre les props supplémentaires propres à ce HOC
		// qui ne devraient pas être transmises au composant enrobé (wrapped).
		//const {title_tab1, content_tab1, title_tab2,content_tab2, ...passThroughProps } = this.props;
		return (
			<div style={{ paddingTop: "0px" }}>

				<Row style={rowStyle}>
					<a onClick={this.handleClick} id="1" style={tabstyle} className={"button item " + class_tab1}>
						{this.props.title_tab1}
					</a>
					<a onClick={this.handleClick} id="2" style={tabstyle} className={"button item " + class_tab2}>
						{this.props.title_tab2}
					</a>
					<a onClick={this.handleClick} id="3" style={tabstyle} className={"button item " + class_tab3}>
						{this.props.title_tab3}
					</a>
				</Row>

				<br />
				
				{safe_content_tab1}
				{safe_content_tab2}
				{safe_content_tab3}
			
			</div>
		)
	}
}
